import { DISCOUNT_ABUSE_BOOKING_REPORT } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  discountAbuseBookings: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const discountAbuseBookingReportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case DISCOUNT_ABUSE_BOOKING_REPORT.REQUEST: {
      return { ...state, isLoading: true };
    }
    case DISCOUNT_ABUSE_BOOKING_REPORT.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        discountAbuseBookings: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case DISCOUNT_ABUSE_BOOKING_REPORT.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default discountAbuseBookingReportReducer;
